import { AxiosError } from 'axios'
import { History } from 'history'

import { AnnounceMode } from '../components/ClinAnnounceBar/ClinAnnounceBar'
import { AppEvent } from '../context/app'
import { createAnnounceEvent } from '../events/AnnounceEvent'

export const patientNotFoundMessage =
  'This patient could not be found, or you do not have access to them.'

/**
 * Patient details answered 404. That is also what the BFF returns for a
 * post-trial access patient the user is not enrolled for, so every patient
 * page treats it the same way: back to the patients list with a plain message,
 * rather than a spinner that never ends or a raw Axios error.
 * Returns true when it handled the error.
 */
export const handlePatientNotFound = (
  error: AxiosError | undefined,
  dispatch: (event: AppEvent) => void,
  history: History
): boolean => {
  if (error?.response?.status !== 404) {
    return false
  }
  dispatch(createAnnounceEvent(AnnounceMode.Error, patientNotFoundMessage))
  history.replace('/patients')
  return true
}
